module.exports = __webpack_public_path__ + "assets/img/34f2128f91dd4a04e3d5ab24f61b68b2.svg";